import React, { useState, useEffect, useCallback } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import { Link } from 'wouter';

import AdminHeader from './AdminHeader';
import QuizApi from '../QuizApi';
import { absURL } from '../utils';

export default function AdminSuperOrganizationList() {

  const [loading, setLoading] = useState(true);
  const [orgList, setOrgList] = useState([]);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await QuizApi.superOrganizationListGet();
      if (!result.success) throw new Error(result.error || 'Fel vid hämtning');
      setOrgList(result.response.organizationList);
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div id="adminSuperOrganizationList">
      <AdminHeader />
      <div className="adminContentWrapper">

        <Button
          variant="outline-secondary"
          size="sm"
          className="mb-3"
          onClick={() => window.history.back()}>
          Tillbaka
        </Button>

        <h5 className="mb-4">Superadmin — organisationer</h5>

        {loading && <Spinner animation="border" />}
        {error && <Alert variant="danger">{error}</Alert>}

        {!loading && !error && (
          <div className="adminTableScroll" style={{ maxWidth: '640px' }}>
            <table className="table table-sm table-hover">
              <thead>
                <tr>
                  <th>Namn</th>
                  <th>Skapad</th>
                  <th>Användare</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {orgList.map(org => (
                  <tr key={org.id}>
                    <td>{org.name}</td>
                    <td>{new Date(org.createdAt).toLocaleDateString('sv-SE')}</td>
                    <td>{org.userCount}</td>
                    <td>
                      <Link href={absURL(`/admin/super/organizations/${org.id}`)}>
                        <Button size="sm" className="btn-quizPrimaryDark">Hantera</Button>
                      </Link>
                    </td>
                  </tr>
                ))}
                {orgList.length === 0 && (
                  <tr><td colSpan={4} className="text-muted">Inga organisationer.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
